exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.shift-hours-list-management-page[data-v-19ae858e] {\n  width: 100%;\n  height: 100%;\n}\n.header[data-v-19ae858e] {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1em 0 1.5rem;\n}\n.btn[data-v-19ae858e] {\n  background-color: #3b8686;\n}\n", ""]);

// exports
